module.exports = __webpack_public_path__ + "static/img/recharge1.1cd5306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recharge1.png
// module id = yQ8O
// module chunks = 4